var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as actions from '../actions/index';
var initialState = {};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a, _b, _c, _d, _e;
    switch (action.type) {
        case actions.REQUEST_FILE_UPLOAD_START:
            var _f = action.payload, file = _f.file, url = _f.url;
            return __assign({}, state, (_a = {}, _a[action.payload.id] = { file: file, url: url, progress: 0, cancelled: false, response: {} }, _a));
        case actions.REQUEST_FILE_UPLOAD_CANCEL:
            return __assign({}, state, (_b = {}, _b[action.payload.id] = __assign({}, state[action.payload.id], { cancelled: true }), _b));
        case actions.RESPONSE_FILE_UPLOAD_PROGRESS:
            return __assign({}, state, (_c = {}, _c[action.payload.id] = __assign({}, state[action.payload.id], { progress: action.payload.progress }), _c));
        case actions.RESPONSE_FILE_UPLOAD_COMPLETE:
            return __assign({}, state, (_d = {}, _d[action.payload.id] = __assign({}, state[action.payload.id], { response: action.payload.response, progress: 100, success: true }), _d));
        case actions.RESPONSE_FILE_UPLOAD_ERROR:
            return __assign({}, state, (_e = {}, _e[action.payload.id] = __assign({}, state[action.payload.id], { error: action.payload }), _e));
        default:
            return state;
    }
}
export var fileError = function (fileId) { return function (state) { return state[fileId].error; }; };
export var fileProgress = function (fileId) { return function (state) { return state[fileId].progress; }; };
export var fileSuccess = function (fileId) { return function (state) {
    return state[fileId].progress === 100 && state[fileId].success;
}; };
export var fileResponse = function (fileId) { return function (state) { return state[fileId].response; }; };
export var fileRequest = function (fileId) { return function (state) { return state[fileId].request; }; };
